<template>
	<div class="group2b_M"><!-- group2b_M -->
	
		
		<report_unit v-if="item.artcount" v-for="(item,index) in resultlist"><!-- report_unit -->
			<template v-if="item.ChildList">
				<ul class="item_title">
					<li class="L"><h1>{{item.colName}}</h1></li>
					<li class="R"></li>
				</ul>
				<template v-for="(citem,cindex) in item.ChildList">
					<ul class="title6">
						<li v-if="citem.colID&&citem.artLst.length" class="L">{{citem.colName}}</li>
						<li v-if="citem.tagId&&citem.artLst.length" class="L">{{citem.tagName}}</li>
						<li v-if="citem.colID&&citem.artLst.length" class="R"><router-link :to="{ name: 'themegj', params: { pagetype: '3', colid: citem.colID }, query: { col : sourcecol }}"  class="more3">更多</router-link></li>
						<li v-if="citem.tagId&&citem.artLst.length" class="R"><router-link :to="{ name: 'themegj', params: { pagetype: '4', colid: citem.tagId }, query: { col : sourcecol }}"  class="more3">更多</router-link></li>
					</ul>
					<ul  class="list5"  >
						<li v-for="(aitem,aindex) in citem.artLst"><L><router-link :to="{ name: 'detail', params: { id: aitem.id }, query: { the : '1' , col : sourcecol}}" v-html="aitem.titleTagName+aitem.articletitle" target="_blank"></router-link></L><R>{{aitem.updateTime.substring(0,10)}}</R></li>
					</ul>
				</template>
			</template>
			<template v-else>
				<ul class="item_title">
					<li class="L"><h1>{{item.colName}}</h1></li>
					<li v-if="item.Type!='4'" class="R"><router-link :to="{ name: 'themegj', params: { pagetype: '3', colid: item.colID }, query: { col : sourcecol }}"  class="more3">更多</router-link></li>
					<li v-else class="R"><router-link :to="{ name: 'themegj', params: { pagetype: '4', colid: item.colID }, query: { col : sourcecol }}"  class="more3">更多</router-link></li>
				</ul>
				<ul  class="list5"  >
					<li v-for="(aitem,aindex) in item.artLst"><L><router-link :to="{ name: 'detail', params: { id: aitem.id }, query: { the : '1' , col : sourcecol}}" v-html="aitem.titleTagName+aitem.articletitle" target="_blank" ></router-link></L><R>{{aitem.updateTime.substring(0,10)}}</R></li>
				</ul>
			</template>
		</report_unit><!-- /report_unit -->
	
	</div><!-- /group2b_M -->
</template>

<script>
	export default{
		props:[
			'resultlist',
			'sourcecol',
		]
	}
</script>

<style>
</style>
